import { object, string } from 'yup';
import { ILoginValidationSchema } from 'views/Auth/Login/interfaces/ILoginValidationSchema';

export const loginValidationSchema = object<ILoginValidationSchema>({
  username: string().required('Username Required'),
  password: string().required('Password Required'),
});

export default loginValidationSchema;
